import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ProfileImageUpload.css";

// Define the types for the state variables
interface ProfileImageUploadState {
  file: File | null;
  previewUrl: string | null;
  uploading: boolean;
  error: string | null;
}

const ProfileImageUpload: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedFile = e.target.files?.[0] || null;
    setFile(selectedFile);
    setError(null);

    if (selectedFile) {
      const preview = URL.createObjectURL(selectedFile);
      setPreviewUrl(preview);
    }
  };

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();

    if (!file) {
      setError("Please select an image to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("ProfileImage", file);

    const token = localStorage.getItem("authToken");
    setUploading(true);

    try {
      const response = await axios.put("https://nrimarriage.in/api/v1/users/Profile", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Profile updated:", response.data);
      navigate("/home");
    } catch (err: any) {
      console.error("Upload error:", err);
      setError(
        err.response?.data?.message || "Failed to upload profile image."
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="profile-upload-container">
      <h2 className="profile-upload-title">Upload Profile Image</h2>
      <form onSubmit={handleSubmit} className="profile-upload-form">
        {previewUrl && (
          <div className="profile-image-preview-wrapper">
            <img
              src={previewUrl}
              alt="Selected"
              className="profile-image-preview"
            />
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="profile-upload-input"
        />
        {error && <p className="profile-upload-error">{error}</p>}
        <button
          type="submit"
          disabled={uploading}
          className="profile-upload-button"
        >
          {uploading ? "Uploading..." : "Upload & Continue"}
        </button>
      </form>
    </div>
  );
};

export default ProfileImageUpload;
